import { ReducerBuilder } from 'reducers/ReducerBuilder';
import { payloadReducer } from 'reducers/reducerUtils';
import * as NutriScoreLabelList from 'types/NutriScore/NutriScoreLabelList';

const rb = new ReducerBuilder<NutriScoreLabelList.Type>();

export const createNutriScoreLabelLoadedAction =
	rb.createActionForReducer<NutriScoreLabelList.Type>(
		payloadReducer((x) => x),
		'NutriScoreLabels/LoadedFromBackend'
	);

export const nutriScoreLabelsReducer = rb.createReducer();
